
const DPRS = [1, 1.5]

export {
  DPRS,
}